import { PDFDownloadLink } from '@react-pdf/renderer';
import Corporate from './Corporate.jsx';

const CorporateQuotation = ({ pdfData }) => {
    if (!pdfData || typeof pdfData !== 'object') {
        return <p>Loading PDF data...</p>;
    }
    const fileName = "corporate-quotation.pdf";
    return (
        <>
            <div className='download-link'>
                <PDFDownloadLink
                    document={<Corporate pdfData={pdfData} />}
                    fileName={fileName}
                >
                    <center>
                        <button className='btn btn-success text-white my-3'>
                            Download Corporate Quotation
                        </button>
                    </center>
                </PDFDownloadLink>
            </div>
        </>
    );
};

export default CorporateQuotation;